import { api } from '../../lib/api';

export type PromoDiscountType = 'PERCENTAGE' | 'FIXED_AMOUNT';

export interface FeaturedPromoCode {
  code: string;
  discountType: PromoDiscountType;
  discountValue: string;
  expiresAt: string | null;
}

export async function getFeaturedPromoCode(): Promise<FeaturedPromoCode | null> {
  const { data } = await api.get('/promo-codes/featured');
  return data;
}
